export enum RentalOrderNodeContext {
  rentVehicleConditionNote = 'RENT_VEHICLE_CONDITION_NOTE',
  returnVehicleConditionNote = 'RETURN_VEHICLE_CONDITION_NOTE',
  rentVehicleNote = 'RENT_VEHICLE_NOTE',
  returnVehicleNote = 'RETURN_VEHICLE_NOTE',
}
